<template>
  <v-list dense>
    <v-subheader v-if="application.actionItems && application.actionItems[0]">
      Candidate Action Required
    </v-subheader>
    <v-subheader v-else> Application Complete </v-subheader>

    <v-list-tile
      v-for="(item, i) in application.actionItems"
      :key="`action-item-${i}`"
      @click=""
    >
      <v-list-tile-avatar>
        <v-icon
          :color="
            item.critical
              ? themes.candidate.light.error
              : themes.candidate.light.warning
          "
        >
          mdi-alert
        </v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <span
          v-if="item.type.split('::')[1] === 'Assessment' && item.description"
        >
          {{
            item.description.includes("APS")
              ? "Missing School Subject"
              : "Pending Assessment"
          }}
        </span>
        <span v-if="item.type.split('::')[1] === 'Avatar'">
          Missing a Profile Image
        </span>
        <span v-if="item.type.split('::')[1] === 'Biography'">
          Missing a Biography
        </span>
        <span v-if="item.type.split('::')[1] === 'Disability'">
          Missing Disability Status
        </span>
        <span v-if="item.type.split('::')[1] === 'EmailConfirmation'">
          Unconfirmed Email Address
        </span>
        <span v-if="item.type.split('::')[1] === 'Ethnicity'">
          Missing Ethnicity
        </span>
        <span v-if="item.type.split('::')[1] === 'Experience'">
          Missing Work Experience
        </span>
        <span v-if="item.type.split('::')[1] === 'Financial'">
          Missing Financial Needs Assessment
        </span>
        <span v-if="item.type.split('::')[1] === 'Flag'">
          Unresolved Flag item
        </span>
        <span v-if="item.type.split('::')[1] === 'Gender'">
          Missing Gender
        </span>
        <span v-if="item.type.split('::')[1] === 'IdentityDocument'">
          Missing a Identity Document
        </span>
        <span v-if="item.type.split('::')[1] === 'Location'">
          Missing Location
        </span>
        <span v-if="item.type.split('::')[1] === 'Mobile'">
          Missing Mobile Number
        </span>
        <span v-if="item.type.split('::')[1] === 'ProfileQualification'">
          Missing Qualifications
        </span>
        <span v-if="item.type.split('::')[1] === 'Registration'">
          Missing a Proof of Registration
        </span>
        <span v-if="item.type.split('::')[1] === 'SecondaryTranscript'">
          Missing Secondary Transcript
        </span>
        <span v-if="item.type.split('::')[1] === 'Submission'">
          Pending answers to screening questions
        </span>
        <span v-if="item.type.split('::')[1] === 'Transcript'">
          Missing Qualification Transcript
        </span>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  props: { application: Object },
};
</script>
